import { render, staticRenderFns } from "./scorecard-edit-order.vue?vue&type=template&id=3ff619ca&scoped=true"
import script from "./scorecard-edit-order.vue?vue&type=script&lang=js"
export * from "./scorecard-edit-order.vue?vue&type=script&lang=js"
import style0 from "./scorecard-edit-order.vue?vue&type=style&index=0&id=3ff619ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff619ca",
  null
  
)

export default component.exports